import { request } from "../packages/base/api/index.js";
import { auth } from "../auth/index.js";

//#region src/api/index.ts
/**
* Make a request to the JW API.
*
* @param service API service/group
* @param action Service action/endpoint
* @param params Endpoint parameters
* @param opts Fetch options
*/
async function jwApi(service, action, params, opts) {
	const operations = (await (await import("./conf.js")).default[service]()).default;
	const authToken = opts?.authToken ?? auth.getToken();
	return request(operations, action, params, {
		...opts,
		authToken
	});
}

//#endregion
export { jwApi };